import React, { useState, useEffect,useLayoutEffect } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import Base from "../core/Base.js";

import * as Yup from "yup";
import axios from "axios";
import { API } from '../backend'
import { APIMEDIA } from '../backend'
import {Link,Redirect,useHistory} from "react-router-dom"


const Signup = () => {
 
  let history=useHistory();

    const initialValues = {
        email: "",
        password: "",
      };
      const onSubmit = (values, submitProps) => {
          console.log(JSON.stringify( values));
        submitProps.setSubmitting(true);
      
        axios
        .post(
            `${API}/signup`,
          JSON.stringify({
            values
          }),
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        ).then(res=>{
            console.log(res)
            if(res.status===200)
            {
              if(res.data.status==true)
              {
            
              alert("Signed up successfully. Please login")
              history.replace('/')
              }
              else
              {
                alert(res.data.error)
              }
             
              
            }
            else
            {
              alert("Hi")
              submitProps.setSubmitting(false);
            }
        });
        
       
      };
      
      const validationSchema = Yup.object({
        email: Yup.string().email("Invalid email format").required("Required"),
        password: Yup.string().required("Required"),
        cpassword: Yup.string()
     .oneOf([Yup.ref('password'), null], 'Passwords must match')
      });
    
       return (
    <Base title="Signup" description="Signup with registered email id">
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        enableReinitialize
      >
        {(formik) => {
          return (
            <Form>
              <div className="row">
                <div className="col-md-4 offset-sm-4 text-left">
                  <div className="form-group">
                    <label className="text-black">Email</label>
                    <Field
                      className="form-control"
                      autoFocus
                      id="email"
                      name="email"
                    />
                    <ErrorMessage name="email">
                      {(errorMsg) => <div className="error">{errorMsg}</div>}
                    </ErrorMessage>
                  </div>
                  <div className="form-group">
                    <label className="text-black">Password</label>
                    <Field
                      className="form-control"
                      id="password"
                      name="password"
                      type="password"
                    />
                    <ErrorMessage name="password">
                      {(errorMsg) => <div className="error">{errorMsg}</div>}
                    </ErrorMessage>
                  </div>
                  <div className="form-group">
                    <label className="text-black">Confirm Password</label>
                    <Field
                      className="form-control"
                      id="cpassword"
                      name="cpassword"
                      type="password"
                    />
                    <ErrorMessage name="cpassword">
                      {(errorMsg) => <div className="error">{errorMsg}</div>}
                    </ErrorMessage>
                  </div>
                  <button
                    type="submit"
                    disabled={ formik.isSubmitting}
                    className="btn btn-success"
                  >
                   
                    <i
                      className={`${
                        formik.isSubmitting ? "fa fa-spinner fa-spin" : "null"
                      }`}
                    ></i>
                    Signup
                  </button>
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </Base>
  );
      
};
export default Signup;
